import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  wrapper: {
    backgroundColor: palette.common.white,
    maxHeight: '660px',
    overflowY: 'auto',
    padding: '24px 40px 0 40px',
    '& .MuiTypography-root + .MuiTypography-root': {
      marginTop: '10px'
    },
    '& .MuiTypography-root + div': {
      marginTop: '24px'
    }
  },
  formItem: {
    marginBottom: '24px'
  },
  squareFtWrapper: {
    maxWidth: '240px'
  },
  inputsWithIconsWrapper: {
    '& .MuiSvgIcon-root path': {
      fill: palette.shades[600]
    }
  }
});
export default useStyles;